export const GOOGLE_BASED_AUTH = "g";
export const PASSWORD_BASED_AUTH = "p";

// Environment Names
export const PRODUCTION = "PRODUCTION";
export const HURRICANE = "HURRICANE";
export const TORNADO = "TORNADO";
export const REVVTEST = "REVVTEST";
export const REVVDEV = "REVVDEV";
export const REVVAI = "REVVAI";
export const MARTINI = "MARTINI";
export const MOJITO = "MOJITO";
export const LOCAL = "LOCAL";

// Domain name in which Website runs
export const WEBSITE_DOMAIN_URL = {
  [PRODUCTION]: "https://www.revv.so",
  [HURRICANE]: "https://www.hurricane.revvsales.com",
  [TORNADO]: "https://www.tornado.revvsales.com",
  [MARTINI]: "https://www.martini.revvsales.com",
  [MOJITO]: "https://www.revvso.xyz",
  [REVVTEST]: "http://www.revvtest.xyz",
  [REVVDEV]: "http://www.revvdev.xyz",
  [REVVAI]: "https://revvai.revvdev.xyz",
  [LOCAL]: "http://localhost:3002",
};

// Domain name in which app runs
export const DOMAIN_NAME = {
  [PRODUCTION]: "revv.so",
  [HURRICANE]: "hurricane.revvsales.com",
  [TORNADO]: "tornado.revvsales.com",
  [MARTINI]: "martini.revvsales.com",
  [MOJITO]: "revvso.xyz",
  [REVVTEST]: "revvtest.xyz",
  [REVVDEV]: "revvdev.xyz",
  [REVVAI]: "revvai.revvdev.xyz",
  [LOCAL]: "localhost:3000",
};

// Auth Urls Mapping
export const AUTH_URL = {
  [PRODUCTION]: "https://www.revv.so/signin",
  [HURRICANE]: "https://hurricane.revvsales.com/signin",
  [TORNADO]: "https://tornado.revvsales.com/signin",
  [MARTINI]: "https://martini.revvsales.com",
  [MOJITO]: "https://www.revvso.xyz/signin",
  [REVVTEST]: "http://www.revvtest.xyz/signin",
  [REVVDEV]: "http://www.revvdev.xyz/signin",
  [REVVAI]: "https://revvai.revvdev.xyz/signin",
  [LOCAL]: "http://localhost:3001/signin",
};

export const DEFAULT_AUTH_REDIRECTION_URL = "assets";

// Google Client Code Mapping for Google auth(Signin & Signup)
export const GOOGLE_AUTH_CLIENT_CODES_MAP = {
  [PRODUCTION]:
    "238279674508-19b8d5kcpsg2kvkv4v9f92nlhqb0chav.apps.googleusercontent.com",
  [HURRICANE]:
    "238279674508-d34g4q9k30vctqnldvpf1ajgf5781p5o.apps.googleusercontent.com",
  [MARTINI]:
    "238279674508-jmlbcr5p449v6almprp46ng8b6llnneq.apps.googleusercontent.com",
  [MOJITO]:
    "210436972305-0vhqisgolela4251fmqsdk4tankn5fi2.apps.googleusercontent.com",
  [LOCAL]:
    "238279674508-ldac2ainc430ngn35319p7qkgjaa5dkn.apps.googleusercontent.com",
};

export const SIGNUP_QESTIONS_MAP = {
  Q11: "Executive Management (CEO, CFO, CRO)",
  Q12: "Senior Sales Management (VP, Director)",
  Q13: "Sales Operations (VP Sales Ops, Director, Manager)",
  Q14: "Front Line Sales (Field Sales, Inside Sales, Channel Sales)",
  Q21: "Contract management",
  Q22: "Quotation Creation",
  Q23: "Granular real time visibility into the deals",
  Q24: "Increasing velocity of approvals",
  Q25: "Cross team collaboration (legal, finance)",
  Q26: "Increase ROI from the sales tech stack/ CRM",
  Q31: "Show me everything you’ve got",
  Q32: "I’ve got 6 minutes or less.",
  Q33: "Wow me in less than 2 minutes.",
};

export const SIGNUP_USER_ROLE = {
  R1: "Contract Management",
  R2: "Quoting Software",
  R3: "Templates and Documents",
  R4: "Proposal Software",
};

export const USER_ROLES = [
  {
    label: SIGNUP_USER_ROLE.R2,
    value: SIGNUP_USER_ROLE.R2,
  },
  {
    label: SIGNUP_USER_ROLE.R4,
    value: SIGNUP_USER_ROLE.R4,
  },
  {
    label: SIGNUP_USER_ROLE.R1,
    value: SIGNUP_USER_ROLE.R1,
  },
  {
    label: SIGNUP_USER_ROLE.R3,
    value: SIGNUP_USER_ROLE.R3,
  },
];
export const SIGNUP_QES_PROBLEMS = [
  {
    id: "21",
    isChecked: false,
    value: SIGNUP_QESTIONS_MAP.Q21,
  },
  {
    id: "22",
    isChecked: false,
    value: SIGNUP_QESTIONS_MAP.Q22,
  },
  {
    id: "23",
    isChecked: false,
    value: SIGNUP_QESTIONS_MAP.Q23,
  },
  {
    id: "24",
    isChecked: false,
    value: SIGNUP_QESTIONS_MAP.Q24,
  },
  {
    id: "25",
    isChecked: false,
    value: SIGNUP_QESTIONS_MAP.Q25,
  },
  {
    id: "26",
    isChecked: false,
    value: SIGNUP_QESTIONS_MAP.Q26,
  },
];

export const SIGNUP_QES_INTEREST_LEVEL = [
  {
    label: SIGNUP_QESTIONS_MAP.Q31,
    value: SIGNUP_QESTIONS_MAP.Q31,
  },
  {
    label: SIGNUP_QESTIONS_MAP.Q32,
    value: SIGNUP_QESTIONS_MAP.Q32,
  },
  {
    label: SIGNUP_QESTIONS_MAP.Q33,
    value: SIGNUP_QESTIONS_MAP.Q33,
  },
];

export const SIGNUP_QESTIONS_LABEL_MAP = {
  [SIGNUP_QESTIONS_MAP.Q11]: "Leadership",
  [SIGNUP_QESTIONS_MAP.Q12]: "Leadership",
  [SIGNUP_QESTIONS_MAP.Q13]: "Leadership/Ops",
  [SIGNUP_QESTIONS_MAP.Q14]: "Rep",
  [SIGNUP_QESTIONS_MAP.Q21]: "Contract Management",
  [SIGNUP_QESTIONS_MAP.Q22]: "Quotation Creation",
  [SIGNUP_QESTIONS_MAP.Q23]: "Real time visibility",
  [SIGNUP_QESTIONS_MAP.Q24]: "Approval velocity",
  [SIGNUP_QESTIONS_MAP.Q25]: "Collaboration",
  [SIGNUP_QESTIONS_MAP.Q26]: "ROI",
  [SIGNUP_QESTIONS_MAP.Q31]: "Detailed",
  [SIGNUP_QESTIONS_MAP.Q32]: "6 mins",
  [SIGNUP_QESTIONS_MAP.Q33]: "2 mins",
};

export const SIGNUP_QES_CHART_CONFIGS = {
  type: "column2d",
  renderAt: "chart-container",
  width: "100%",
  height: "330",
  dataFormat: "json",
  dataSource: {
    chart: {
      theme: "fusion",
      caption: "We know many who had the same issues",
      xAxisName: "Problems",
      yAxisName: "% of people",
      showlegend: "1",
      baseFontSize: "11",
      paletteColors: "#FF0078, #0A00FF, #FF9200, #9900FF, #06D342, #00AAFF",
      maxColWidth: "45",
      showValues: "1",
      numberSuffix: "%",
    },
    data: [],
  },
};

export const SIGNUP_QES_CHART_DATA_MAP = {
  "1": [25, 16.5, 18.0, 12.0, 14.25, 14.25],
  "2": [21.88, 19.79, 16.04, 16.77, 13.56, 11.96],
  "3": [23.78, 22.89, 20.0, 11.11, 9.44, 12.78],
  "4": [21.88, 22.42, 21.88, 19.17, 6.67, 10.0],
  "5": [18.7, 19.25, 16.87, 17.05, 19.8, 8.33],
  "6": [17.83, 18.33, 17.33, 15.5, 15.67, 15.33],
};

export const SIGNUP_FORM_OPTIONS = {
  TITLE: [
    { value: "CxO/General Manager", label: "CxO/General Manager" },
    { value: "Business Owner/Partner", label: "Business Owner/Partner" },
    { value: "VP/Executive", label: "VP/Executive" },
    { value: "IT Manager", label: "IT Manager" },
    { value: "Operations Manager", label: "Operations Manager" },
    {
      value: "Sales Manager",
      label: "Sales Manager",
    },
    {
      value: "Developer/Software Engineer/Analyst",
      label: "Developer/Software Engineer/Analyst",
    },
    {
      value: "Personal Interest",
      label: "Personal Interest",
    },
    {
      value: "Student",
      label: "Student",
    },
    { value: "Others", label: "Others" },
  ],
  COMPANY_SIZE: [
    { value: "1 - 10 employees", label: "1 - 10 employees" },
    { value: "11 - 50 employees", label: "11 - 50 employees" },
    { value: "51 - 100 employees", label: "51 - 100 employees" },
    { value: "101 - 500 employees", label: "101 - 500 employees" },
    { value: "501 - 1500 employees", label: "501 - 1500 employees" },
    { value: "1501+ employees", label: "1501+ employees" },
  ],
};

export const SIGNUP_ONBOARD_CHECKLIST = {
  pricebooks: true,
  products: true,
  templates: true,
};



// WEBPACK FOOTER //
// ./src/constants/auth.js